import { render, staticRenderFns } from "./BrowseTile.vue?vue&type=template&id=004c5f0d&scoped=true&"
import script from "./BrowseTile.vue?vue&type=script&lang=js&"
export * from "./BrowseTile.vue?vue&type=script&lang=js&"
import style0 from "./BrowseTile.vue?vue&type=style&index=0&id=004c5f0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c5f0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
